import { computed, getCurrentInstance } from 'vue'
import { useAccountStore } from '@/stores/account'
import { MemberLevel } from '@/constants/account'

const useBus = () => {
  const instance = getCurrentInstance()
  return instance?.appContext.config.globalProperties.$bus
}

const useMemberLevel = () => {
  const accountStore = useAccountStore()
  const member = computed(() => accountStore.memberInfo)

  // 具有试用权限会员
  const authFree = () =>
    !!member.value &&
    !!member.value.userMember &&
    member.value.userMember.member.id >= MemberLevel.FREE
  // 具有普通会员权限
  const authBasic = () =>
    !!member.value &&
    !!member.value.userMember &&
    member.value.userMember.member.id >= MemberLevel.TRIAL
  // 具有高级会员权限
  const authAdvanced = () =>
    !!member.value &&
    !!member.value.userMember &&
    member.value.userMember.member.id >= MemberLevel.PROFESSIONAL
  // 具有企业版权限
  const authEnterpriseEdition = () =>
    !!member.value &&
    !!member.value.userMember &&
    member.value.userMember.member.id >= MemberLevel.ENTERPRISE
  // 具有高级会员权限
  const authEnterpriseCustomizedVersion = () =>
    !!member.value &&
    !!member.value.userMember &&
    member.value.userMember.member.id >= MemberLevel.ENTERPRISE_CUSTOMIZED
  // 国际版
  // 具有Starter会员
  const authStarter = () =>
    !!member.value &&
    !!member.value.userMember &&
    member.value.userMember.member.id >= MemberLevel.STARTER
  const authPlus = () =>
    !!member.value &&
    !!member.value.userMember &&
    member.value.userMember.member.id >= MemberLevel.PLUS
  const authPro = () =>
    !!member.value &&
    !!member.value.userMember &&
    member.value.userMember.member.id >= MemberLevel.PRO

  return {
    authFree,
    authBasic,
    authAdvanced,
    authEnterpriseEdition,
    authEnterpriseCustomizedVersion,
    authStarter,
    authPlus,
    authPro
  }
}

export { useBus, useMemberLevel }
